import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SocialLogin from './SocialLogin';
import './LoginTab.scss';
import '../../../theme/form-style-label-animation.scss';
import { Form, Field } from 'react-final-form';
import GupshupWhatsapp from '../../../CommonComponents/GupshupWhatsapp';
import CountryCodeInput from '../../../CommonComponents/CountryCodeInput/CountryCodeInput';
import { setCurrentWhatsappStatus } from '../../../actionCreators/gupshupWhatsapp';
import { langCodeAllowed } from '../../../locales';
import BannerPdpDetail from './BannerPdpDetail';
import config from '../../../config';
import { pushDataLayerEvent } from '../../../utils/DataLayer';
import { emailCriteriaFulfilled, onlyNumbersEntered } from '../../../utils/helper';
import { phoneCodeToShow } from '../../../helpers/countryConfig';
import ForgotPassword from './ForgotPassword';

class LoginTab extends Component {
  static propTypes = {
    showPassCallback: PropTypes.func,
    hideLogin: PropTypes.func,
    userInfo: PropTypes.object,
    login: PropTypes.bool,
    loginError: PropTypes.string,
    user: PropTypes.object,
    registerActions: PropTypes.any,
    commonActions: PropTypes.any,
    redisCommonData: PropTypes.object,
    userInputValidate: PropTypes.object,
    oTPSent: PropTypes.any,
    userInputErr: PropTypes.object,
    oTPLoginSuccess: PropTypes.any,
    loginFromCL: PropTypes.bool,
  };

  constructor(props, context) {
    const { redisCommonData, localeInfo } = props;
    const { phoneCode } = langCodeAllowed[localeInfo.countryCode];
    let WHATSAPP_OPTIN = redisCommonData.WHATSAPP_OPTIN
      ? JSON.parse(redisCommonData.WHATSAPP_OPTIN)
      : {};
    WHATSAPP_OPTIN = (WHATSAPP_OPTIN.Desktop && WHATSAPP_OPTIN.Desktop.Login) || {};
    super(props, context);
    this.errorUsername = null;
    this.otpResent = '';
    this.errorPassword = null;
    this.emailValid = false;
    this.phoneValid = false;
    this.triggerOfferGa = true;
    this.toggleBlock = false;
    this.username = '';
    this.state = {
      showEditText: false,
      showForgotPass: false,
      whatsappOptin: WHATSAPP_OPTIN,
      isUserOptInForWhatsapp: WHATSAPP_OPTIN.toggle === 'ON',
      isCaptchaVerified: false,
      captchaResponse: null,
      showCountryCode: false,
      currentPhoneCodeSelected: phoneCode,
    };
    this.getCheckBoxStatus = this.getCheckBoxStatus.bind(this);
    this.verifyCaptchaCallback = this.verifyCaptchaCallback.bind(this);
    this.renderCaptcha = this.renderCaptcha.bind(this);
    this.changePhoneCode = this.changePhoneCode.bind(this);
  }

  componentDidMount() {
    const { registerActions } = this.props;
    registerActions.resetAuthData();
    if (this.props.isCaptchaRequired) {
      this.renderCaptcha();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      userInputValidate,
      oTPSent,
      oTPLoginSuccess,
      user,
      commonActions,
      hideLogin,
      loginFromCL,
      setCurrentWhatsappStatus,
      isDesktopPdp,
      showSignUp,
      hasPlacedOrder,
    } = this.props;
    const { isUserOptInForWhatsapp } = this.state;
    // If => user entered mobile/email is not there in mobile login db
    // else if => user enterd mobile is there in mobile login db then send OTP to user mobile
    // else if => user entered email is there in mobile login db the show password field for user
    if (
      prevProps.userInputValidate !== userInputValidate &&
      userInputValidate &&
      userInputValidate.result.accounts.length === 0 &&
      window.dtm.LenskartRewamp
    ) {
      window.dtm.LenskartRewamp.loginPopup.load.loginPopupAccountNotFound();
    } else if (
      prevProps.userInputValidate !== userInputValidate &&
      userInputValidate &&
      userInputValidate.result.accounts.length > 0 &&
      userInputValidate.result.data.validBlock === 'mobile'
    ) {
      this.fnSendValidateOtp(userInputValidate.result, 'SEND_OTP');
    }
    // OTP sent to the user for mobile login valid user and counter of showing edit/resed otp started.
    if (prevProps.oTPSent !== oTPSent && oTPSent === true) {
      this.setTimeout();
    }
    if (
      (!prevProps.user && user) ||
      (prevProps.oTPLoginSuccess !== oTPLoginSuccess && oTPLoginSuccess === true)
    ) {
      if (window.dtm.LenskartRewamp) window?.dtm?.LenskartRewamp?.loginSuccess?.success();
      if (
        userInputValidate.result &&
        userInputValidate.result.data &&
        userInputValidate.result.data.validBlock === 'mobile'
      ) {
        setCurrentWhatsappStatus(isUserOptInForWhatsapp);
      }
      // Offer Modal : User has placed the order, Authmodal should hide
      if ((hideLogin && !isDesktopPdp) || hasPlacedOrder) hideLogin();
      // Offer Modal : User didn't placed order, Show signup tab to get campaign data
      if (isDesktopPdp && !hasPlacedOrder) {
        showSignUp();
      }
      commonActions.getUserInfo();
      commonActions.shortlist('', 'get', '?attributes=true');
      if (!loginFromCL)
        _gaq.push([
          '_trackEvent',
          'SIGNUP POPUP',
          'Login Success',
          `page: ${document.location.pathname}${document.location.search}`,
        ]);
      _gaq.push([
        'ninja._trackEvent',
        'SIGNUP POPUP',
        'Login Success',
        `page: ${document.location.pathname}${document.location.search}`,
      ]);
      if (window.prevUrl) window.history.back();
    }
    if (
      prevProps.isCaptchaRequired !== this.props.isCaptchaRequired &&
      this.props.isCaptchaRequired
    ) {
      this.renderCaptcha();
    } else if (
      prevProps.isCaptchaRequired === this.props.isCaptchaRequired &&
      this.props.isCaptchaRequired &&
      this.state.isCaptchaVerified &&
      prevProps.oTPSent !== this.props.oTPSent
    ) {
      this.resetCaptcha();
    } else if (
      prevProps.isCaptchaRequired !== this.props.isCaptchaRequired &&
      !this.props.isCaptchaRequired
    ) {
      this.setCaptcha(null);
    }
    const offerFlow = sessionStorage.getItem('offerSelected');
    if (this.phoneValid && offerFlow && this.triggerOfferGa) {
      const offerGtm = {
        event: 'lead form',
        pageName: 'otp lead',
        pageType: 'lead form',
        category: '',
        channel: '',
        subSection1: '',
        PageUrl: window?.location.href || '',
        LkUserType: 'lkNew',
        loginStatus: 'guest',
      };
      pushDataLayerEvent(offerGtm);
      this.triggerOfferGa = false;
    }
    if (this.username !== this.props.username) this.username = this.props.username;
  }

  componentWillUnmount() {
    if (window.secondsTimer) {
      clearInterval(window.secondsTimer);
    }
  }

  setTimeout = () => {
    const otpInput = document.querySelector('.otpPasswordField');
    if (otpInput) {
      otpInput.focus();
    }
    const { redisCommonData } = this.props;
    let timer = redisCommonData.timerForWalletResendOTP / 1000;
    window.secondsTimer = setInterval(() => {
      if (timer > ('0' || '00' || 0)) {
        timer -= 1;
        if (timer < ('10' || 10)) {
          timer = `0${timer}`;
        }
      }
      if (timer === ('00' || 0)) {
        this.setState({
          showEditText: true,
        });
        this.resetTimeOUt();
      }
      if (document.getElementById('otpTimer') && !isNaN(timer))
        document.getElementById('otpTimer').innerHTML = `00:${timer}`;
    }, 1000);
  };

  setCaptcha = response => {
    this.setState({
      captchaResponse: response,
    });
  };

  getCheckBoxStatus(userWhatsappOptinStatus) {
    this.setState({ isUserOptInForWhatsapp: userWhatsappOptinStatus });
  }

  forgotPassword = () => {
    const { showPassCallback } = this.props;
    showPassCallback();
    this.setState({ showForgotPass: true });
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.checkout.load.loginForgotPassword('account');
  };

  verifyCaptchaCallback = response => {
    if (response.length !== 0) {
      this.setState({
        isCaptchaVerified: true,
        captchaResponse: response,
      });
    }
  };

  handleLogin = value => {
    const { emailValid, phoneValid } = this;
    const { registerActions, userInputValidate, localeInfo } = this.props;
    const { currentPhoneCodeSelected } = this.state;
    const { maxMobileNumberLength, minMobileNumberLength } =
      langCodeAllowed[localeInfo.countryCode];
    const data = {
      username: value.emailOrPhone,
    };

    if (!this.props.oTPSent) {
      value.otppassword = '';
    }
    if (!this.props.userInputValidate) {
      value.password = '';
    }
    if (value.password) data.password = value.password;
    if (value.otppassword) data.code = value.otppassword;
    // Below code to check the valid block with regEx for email and mobile number

    if (isNaN(data.username) && !emailValid) {
      data.validBlock = 'email';
      data.phoneCode = currentPhoneCodeSelected;
      registerActions.validateUserInput(data);
    } else if (
      !phoneValid &&
      data.username &&
      data.username.length <= maxMobileNumberLength &&
      data.username.length >= minMobileNumberLength
    ) {
      window.timeOutTimer = null;
      data.validBlock = 'mobile';
      data.phoneCode = currentPhoneCodeSelected;
      registerActions.validateUserInput(data);
    }
    if (
      phoneValid &&
      value.otppassword !== '' &&
      (userInputValidate.result.type === 'SEND_OTP' ||
        userInputValidate.result.type === 'VALIDATE_OTP')
    ) {
      this.fnSendValidateOtp(data, 'VALIDATE_OTP');
    }
    // Below code is to check if user has entered emailId then validate and let user login
    if (emailValid && value.password !== '') {
      this.doLogin(data, 'emailValid');
    }
    if (
      !phoneValid &&
      data.username &&
      (data.username.length > maxMobileNumberLength || data.username.length < minMobileNumberLength)
    ) {
      this.isMobileEmail(data.username);
    }
  };

  editValue = type => {
    const { registerActions } = this.props;
    this.resetTimeOUt();
    registerActions.resetMobileLoginProps();
    if (type !== 'resend-otp') {
      this.emailValid = false;
      this.phoneValid = false;
      this.toggleBlock = false;
      this.setState({ showEditText: false });
      this.errorPassword = null;
      this.otpResent = '';
    }
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.loginPopup.load.loginPopupEditEmailNumber('email');
  };

  makeLoginApiCall = (data, errorPassword, errorEmail, validBlock) => {
    const { registerActions } = this.props;
    this.otpResent = '';
    if (
      (validBlock === 'emailValid' && !errorEmail) ||
      (validBlock === 'phoneValid' && !errorEmail)
    ) {
      registerActions.authenticateUser(data);
    }
  };

  doLogin = (data, validBlock) => {
    const { errorPassword, errorEmail } = this;
    this.otpResent = '';
    if (validBlock === 'emailValid') {
      this.errorPassword = null;
      this.resetTimeOUt();
      this.makeLoginApiCall(data, errorPassword, errorEmail, validBlock);
    }
  };

  fnSendValidateOtp = (data, type, occurence) => {
    const { registerActions } = this.props;
    const { currentPhoneCodeSelected } = this.state;
    if (window.dtm.LenskartRewamp) {
      if (occurence === 'Resend') {
        window.dtm.LenskartRewamp.loginPopup.load.loginPopupResendOtp(data.data.username);
      } else if (type !== 'VALIDATE_OTP') {
        window.dtm.LenskartRewamp.loginPopup.load.loginPopupEnterOtp(data.data.username);
      }
    }
    data.type = type;
    data.phoneCode = currentPhoneCodeSelected;
    data.captchaKey = this.state.captchaResponse;
    data.occurence = occurence;
    registerActions.sendValidateOtp(data);
  };

  resetTimeOUt = () => {
    clearInterval(window.secondsTimer);
  };
  required = value => (value ? undefined : this.props.dataLocale.THIS_IS_REQUIRED_FIELD);
  isMobileEmail = value => {
    const { localeInfo, dataLocale } = this.props;
    const { regex, maxMobileNumberLength, minMobileNumberLength } =
      langCodeAllowed[localeInfo.countryCode];
    let error = null;
    if (
      (!regex.test(value) ||
        (value &&
          (value.length > maxMobileNumberLength || value.length < minMobileNumberLength))) &&
      !emailCriteriaFulfilled(value)
    ) {
      error = dataLocale.PLEASE_ENTER_VALID_EMAIL_MOBILE;
    }
    if (
      value &&
      (emailCriteriaFulfilled(value) ||
        !onlyNumbersEntered(value) ||
        value.length > maxMobileNumberLength)
    ) {
      this.setState({
        showCountryCode: false,
      });
    } else if (!value) {
      this.setState({
        showCountryCode: false,
      });
    } else {
      this.setState({
        showCountryCode: true,
      });
    }
    return error;
  };

  resetCaptcha = () => {
    window.grecaptcha.reset();
    this.setState({
      isCaptchaVerified: false,
      captchaResponse: null,
    });
  };

  changePhoneCode = code => {
    this.setState({ currentPhoneCodeSelected: code });
  };

  renderCaptcha = () => {
    window.grecaptcha.render('recaptcha', {
      sitekey: config.siteKey,
      theme: 'light',
      callback: this.verifyCaptchaCallback,
      'expired-callback': this.resetCaptcha,
    });
    this.setState({
      isCaptchaVerified: false,
    });
  };

  render() {
    const {
      redisCommonData,
      userInputValidate,
      oTPSent,
      otpType,
      loginError,
      userInputErr,
      username,
      loading,
      loginFromCL,
      localeInfo,
      dataLocale,
      bannerImg,
      isDesktopPdp,
      productData,
      productOfferDetails,
      isCaptchaRequired,
    } = this.props;
    const {
      VERIFY,
      EDIT_EMAIL,
      OTP,
      ACCOUNT_DOES_NOT_EXIST,
      MOBILE_EMAIL_TEXT,
      BACK,
      WE_HAVE_SENT_AN_OTP,
      HYPHEN,
      PLEASE_ENTER_OTP,
      EDIT_NUMBER,
      A_NEW_OTP_SENT,
      RESEND,
      PLEASE_ENTER_PASSWORD,
      EMAIL_ADDRESS,
      FORGOT_PASSWORD,
      PASSWORD,
      PROCEED,
      BANNER,
      LOGO,
    } = dataLocale;
    const { showEditText, whatsappOptin, showCountryCode, currentPhoneCodeSelected } = this.state;
    const { timerForWalletResendOTP, AVAILABLE_NEIGHBOUR_COUNTRIES } = redisCommonData;
    const countryConfig = AVAILABLE_NEIGHBOUR_COUNTRIES
      ? phoneCodeToShow(JSON.parse(AVAILABLE_NEIGHBOUR_COUNTRIES))
      : {};
    // const isIndia = localeInfo.countryCode === 'in';
    const showDownArrow = localeInfo.countryCode !== 'ae';
    if (
      userInputValidate != null &&
      userInputValidate.result.accounts.length > 0 &&
      userInputValidate.result.data.validBlock === 'email'
    ) {
      this.emailValid = true;
      this.toggleBlock = true;
      this.errorUsername = null;
      this.phoneValid = false;
    }
    if (userInputValidate && userInputValidate.result.accounts.length === 0) {
      this.errorUsername = ACCOUNT_DOES_NOT_EXIST;
    }

    // OTP sent to the user for mobile login valid user and counter of showing edit/resed otp started.
    if (oTPSent && oTPSent === true) {
      this.errorUsername = null;
      this.emailValid = false;
      this.phoneValid = true;
      this.toggleBlock = true;
    }

    if (userInputErr !== null && userInputErr.message && userInputValidate === null) {
      this.errorUsername = userInputErr.message;
      this.otpResent = '';
    }

    // User entered OTP does not match
    if (typeof oTPSent !== 'boolean' && oTPSent.error) {
      this.errorPassword = oTPSent.error.message;
      this.otpResent = '';
    }

    if (loginError) {
      this.errorPassword = loginError.message;
      this.otpResent = '';
      if (!loginFromCL)
        _gaq.push([
          '_trackEvent',
          'SIGNUP POPUP',
          'Login Failure',
          `page: ${document.location.pathname}${document.location.search}`,
        ]);
      _gaq.push([
        'ninja._trackEvent',
        'SIGNUP POPUP',
        'Login Failure',
        `page: ${document.location.pathname}${document.location.search}`,
      ]);
    }
    return !this.state.showForgotPass ? (
      <div className="login-wrapper display-flex">
        {!loginFromCL && (
          <div className="auth-section_left-col">
            {isDesktopPdp ? (
              <BannerPdpDetail
                dataLocale={dataLocale}
                offerText={productOfferDetails && productOfferDetails.text1}
                productData={productData}
              />
            ) : (
              <img
                alt={BANNER}
                className="res-img"
                src={
                  bannerImg ||
                  'https://static.lenskart.com/media/wysiwyg/sign-register/sign-in-offer.jpg'
                }
                style={{ height: '100%' }}
              />
            )}
          </div>
        )}
        <div className="auth-section_right-col">
          <Form
            initialValues={{
              emailOrPhone: (this.username && username) || '',
              otppassword: '',
              email: username || '',
              password: '',
            }}
            render={({ handleSubmit, submitting }) => (
              <form
                noValidate
                className="form-SLA frm-login"
                name="register"
                onSubmit={handleSubmit}
              >
                <ul className={!this.toggleBlock ? '' : 'screen-hidden'}>
                  <li className="input-filed-col">
                    <Field name="emailOrPhone" validate={this.isMobileEmail}>
                      {({ input, meta }) => {
                        return (
                          <div
                            className={`form-SLA_field-row ${
                              meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''
                            }`}
                          >
                            <div className="display-flex pos-rel">
                              <CountryCodeInput
                                changeDropDown={this.changePhoneCode}
                                countryConfig={countryConfig}
                                imgCssStyle={{
                                  display: showCountryCode && !showDownArrow ? 'block' : 'none',
                                }}
                                inputCssClass={`inline-block margin-r5 pos-abs fw-bold ${
                                  showCountryCode ? 'country-code-display-50' : ''
                                }`}
                                inputCssStyle={{
                                  bottom: '7px',
                                  display: showCountryCode ? 'block' : 'none',
                                }}
                                localeInfo={localeInfo}
                                selectCssClass={`inline-block margin-r5 ${
                                  showCountryCode ? 'country-code-display-50' : ''
                                } pos-abs fw-bold text-center moz-left`}
                                selectCssStyle={{
                                  height: '100%',
                                  left: '0',
                                  top: '1px',
                                  display: showCountryCode ? 'block' : 'none',
                                }}
                              />
                              <input
                                {...input}
                                autoComplete="emailOrPhone"
                                className={
                                  meta.valid || (meta.error && meta.dirty)
                                    ? 'form-SLA_field-row_label'
                                    : ''
                                }
                                placeholder={MOBILE_EMAIL_TEXT}
                                title={MOBILE_EMAIL_TEXT}
                                type="text"
                                onFocus={() => {
                                  this.errorUsername = null;
                                }}
                              />
                            </div>
                            {(meta.error && meta.touched) ||
                              (oTPSent.error && oTPSent.error.message && otpType === 'SEND_OTP' && (
                                <span className="form-SLA_field-row_error">
                                  {meta.error || oTPSent.error.message}
                                </span>
                              ))}
                          </div>
                        );
                      }}
                    </Field>
                    {(userInputValidate || userInputErr) && this.errorUsername && (
                      <div className="custom-error">{this.errorUsername}</div>
                    )}
                  </li>
                </ul>

                {this.phoneValid && (
                  <ul>
                    <li
                      aria-hidden="true"
                      className="arrow-back"
                      onClick={() => {
                        this.editValue('edit-email');
                      }}
                    >
                      <i className="fa fa-arrow-left"></i>
                      {BACK}
                    </li>
                    <li className="input-filed-col margin-t18 margin-b18">
                      <span>
                        {WE_HAVE_SENT_AN_OTP} {currentPhoneCodeSelected} {HYPHEN} {username}{' '}
                        <span
                          className="edit phone pull-right"
                          onClick={() => {
                            this.editValue('edit-phone');
                            if (window.dtm.LenskartRewamp)
                              window.dtm.LenskartRewamp.loginPopup.load.loginPopupEditEmailNumber(
                                'phone'
                              );
                          }}
                        >
                          {' '}
                          {EDIT_NUMBER}
                        </span>
                      </span>
                    </li>
                    <li className="input-filed-col otppassword clearboth">
                      <Field name="otppassword" validate={this.required}>
                        {({ input, meta }) => (
                          <div
                            className={`form-SLA_field-row ${
                              meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''
                            }`}
                          >
                            <input
                              {...input}
                              autoComplete="otppassword"
                              className={
                                meta.valid || (meta.error && meta.dirty)
                                  ? 'form-SLA_field-row_label otpPasswordField'
                                  : ''
                              }
                              maxLength="6"
                              placeholder={PLEASE_ENTER_OTP}
                              title={OTP}
                              type="text"
                              onFocus={() => {
                                this.errorPassword = null;
                              }}
                            />
                            <span
                              className={`margin-t5 pull-right resend ${
                                !this.state.isCaptchaVerified && isCaptchaRequired
                                  ? 'resend-disable'
                                  : ''
                              }`}
                              onClick={() => {
                                this.fnSendValidateOtp(
                                  userInputValidate.result,
                                  'SEND_OTP',
                                  'Resend'
                                );
                                this.errorPassword = null;
                                this.otpResent = A_NEW_OTP_SENT;
                                this.setState({ showEditText: false });
                              }}
                            >
                              <span className="display-timer margin-r5" id="otpTimer">
                                {timerForWalletResendOTP / 1000 >= 10
                                  ? `00:${timerForWalletResendOTP / 1000}`
                                  : `00:0${timerForWalletResendOTP / 1000}`}
                              </span>
                              <span className="resend-text">{RESEND}</span>
                            </span>
                            {meta.error && meta.touched && (
                              <span className="form-SLA_field-row_error">{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </li>
                    <li
                      className={`overflow-h ${
                        showEditText ? 'input-filed-col' : 'input-filed-col resend-list'
                      }`}
                    >
                      {this.errorPassword && (
                        <div className="custom-error custom-phone-error">{this.errorPassword}</div>
                      )}
                      {this.otpResent !== '' && (
                        <div className="validation-advice otp-resent">{this.otpResent}</div>
                      )}
                    </li>
                  </ul>
                )}
                {this.emailValid && (
                  <ul>
                    <li
                      aria-hidden="true"
                      className="arrow-back"
                      onClick={() => {
                        this.editValue('edit-email');
                      }}
                    >
                      <i className="fa fa-arrow-left"></i>
                      {BACK}
                    </li>
                    <li className="input-filed-col">
                      <Field name="email">
                        {({ input, meta }) => (
                          <div
                            className={`form-SLA_field-row ${
                              meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''
                            }`}
                          >
                            <input
                              {...input}
                              autoComplete="otppassword"
                              className={
                                meta.valid || (meta.error && meta.dirty)
                                  ? 'form-SLA_field-row_label validate-email'
                                  : 'validate-email'
                              }
                              disabled="disabled"
                              title={EMAIL_ADDRESS}
                              type="email"
                              value={username}
                            />
                          </div>
                        )}
                      </Field>
                      <span
                        className="edit"
                        onClick={() => {
                          this.editValue('edit-email');
                        }}
                      >
                        {EDIT_EMAIL}
                      </span>
                    </li>
                    <li className="input-filed-col col-current-password">
                      <Field name="password" validate={this.required}>
                        {({ input, meta }) => (
                          <div
                            className={`form-SLA_field-row ${
                              meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''
                            }`}
                          >
                            <input
                              {...input}
                              autoComplete="current-password"
                              className={
                                meta.valid || (meta.error && meta.dirty)
                                  ? 'form-SLA_field-row_label validate-password'
                                  : 'validate-password'
                              }
                              placeholder={PLEASE_ENTER_PASSWORD}
                              title={PASSWORD}
                              type="password"
                              onFocus={() => {
                                this.errorPassword = null;
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span className="form-SLA_field-row_error">{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      {!loginFromCL && (
                        <a
                          className="pull-right display-ib margin-t5 margin-b15 btn-forgot-password"
                          onClick={this.forgotPassword}
                        >
                          {FORGOT_PASSWORD}
                        </a>
                      )}
                      {this.errorPassword && (
                        <div className="custom-error display-ib">{this.errorPassword}</div>
                      )}
                    </li>
                  </ul>
                )}
                {this.props.isCaptchaRequired && <div id="recaptcha"></div>}
                {this.props.isCaptchaRequired && this.props.oTPSent && (
                  <button
                    className={`margin-t5 pull-left verify-btn ${
                      this.state.isCaptchaVerified ? 'isEnabled' : ''
                    }`}
                    disabled={!this.state.isCaptchaVerified && this.props.isCaptchaRequired}
                    onClick={() => {
                      this.fnSendValidateOtp(userInputValidate.result, 'SEND_OTP', 'Resend');
                      this.errorPassword = null;
                      this.otpResent = A_NEW_OTP_SENT;
                      this.setState({ showEditText: false });
                    }}
                  >
                    <span className="resend-text">{VERIFY}</span>
                  </button>
                )}
                <div className={this.phoneValid ? 'clearboth phone-valid' : 'clearboth'}>
                  <div className="padding-t15 text-center">
                    {!loading ? (
                      <button
                        className="form-SLA_field-row_submit"
                        disabled={
                          submitting ||
                          (!this.state.isCaptchaVerified &&
                            this.props.isCaptchaRequired &&
                            !oTPSent)
                        }
                        name="send"
                        type="submit"
                      >
                        {PROCEED}
                      </button>
                    ) : (
                      <img
                        alt={LOGO}
                        src="//static.lenskart.com/skin/frontend/base/default/images/loader2.gif"
                      />
                    )}
                  </div>
                  {whatsappOptin.showWidget && localeInfo.countryCode !== 'sg' && (
                    <GupshupWhatsapp
                      WHATSAPP_OPTIN={whatsappOptin}
                      checkBoxStatus={this.getCheckBoxStatus}
                      page="Desktop-Login"
                    />
                  )}
                  {!loginFromCL && <SocialLogin {...this.props} />}
                </div>
              </form>
            )}
            onSubmit={this.handleLogin}
          />
        </div>
      </div>
    ) : (
      <ForgotPassword
        {...this.props}
        showLoginCallback={() => {
          this.setState({ showForgotPass: false });
          clearTimeout(window.timeOutTimer);
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  localeInfo: state.common.localeInfo,
  isCaptchaRequired: state.auth.isCaptchaRequired,
  otpType: state.auth.otpType,
});

const mapDispatchToProps = dispatch => {
  return {
    setCurrentWhatsappStatus: status => dispatch(setCurrentWhatsappStatus(status)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginTab);
